import Teradamai1 from '../Teradamai/Teradamai (1).webp'
import Teradamai2 from '../Teradamai/Teradamai (2).webp'
import Teradamai3 from '../Teradamai/Teradamai (3).webp'
import Teradamai4 from '../Teradamai/Teradamai (4).webp'
import Teradamai5 from '../Teradamai/Teradamai (5).webp'
import Teradamai6 from '../Teradamai/Teradamai (6).webp'
import Teradamai7 from '../Teradamai/Teradamai (7).webp'
import Teradamai8 from '../Teradamai/Teradamai (8).webp'
import Teradamai9 from '../Teradamai/Teradamai (9).webp'



const Teradamaiimages =[ 
    Teradamai1,Teradamai2,Teradamai3,Teradamai4,Teradamai5,Teradamai6,Teradamai7,Teradamai8,Teradamai9
]

export default Teradamaiimages;